import React, { useState } from "react";
import { ReactComponent as Spark } from "../../assets/analyse/Spark.svg";
import { ReactComponent as Truck } from "../../assets/analyse/Truck.svg";
import { ReactComponent as Box } from "../../assets/analyse/Box.svg";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { setUserOnboardingStep, setUserOnboardingStepLocal } from "../../redux/actions/userActions";

const ReductionOption = ({ text, state, update, data, indicator }) => {
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)

  const dispatch = useDispatch();
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const setUserOnboardingStep_rd = (item) => dispatch(setUserOnboardingStep(item));
  const setUserOnboardingStepLocal_rd = (item) => dispatch(setUserOnboardingStepLocal(item));
  const handleChangeOnboardingStep = (item) => {
    setUserOnboardingStep_rd(item);
    setUserOnboardingStepLocal_rd(item);
  };

  const totalScore = analysis_data["unique_score"];

  const [transport, setTransport] = useState(false);
  const [energy, setEnergy] = useState(false);
  const [packaging, setPackaging] = useState(false);

  const calcul_normalized_single_score = (single_score) => {
    // eslint-disable-next-line radix
    return Math.round(100 - (Math.log(10 * single_score + 1) / Math.log(2 + 1 / (100 * single_score ** 4))) * 20);
  };

  const calculStepImpactIndicator = (step_index, indicator_id, k_type) => {
    let flow_impact;
    if (step_index !== 2) {
      const k_type_data = analysis_data.lca.lca_steps[6 - step_index].inputs ? analysis_data.lca.lca_steps[6 - step_index].inputs.filter((x) => x.flow.category.name === k_type) : [];
      flow_impact = k_type_data.reduce((acc, crr) => {
        const coefficient = crr.flow.flow_impact_factors.find((x) => x.id === indicator_id).coefficient;
        const conversion_factor = crr.unit.conversion_factor;
        const amount = crr.amount;
        acc += coefficient * conversion_factor * amount;
        return acc;
      }, 0);
    } else if (step_index === 2) {
      // const k_type_data = analysis_data.lca.lca_steps[6 - step_index].inputs ? analysis_data.lca.lca_steps[6 - step_index].inputs : [];
      // flow_impact = k_type_data.reduce((acc, crr) => {
      //   if (crr) {
      //     const coefficient = parseFloat(crr.flow.flow_impact_factors.find((x) => x.id === indicator_id).coefficient);
      //     const conversion_factor = parseFloat(crr.unit.conversion_factor);
      //     const amount = parseFloat(crr.amount);
      //     acc += coefficient * conversion_factor * amount;
      //   }
      //   return acc;
      // }, 0);
      // console.log('flow_impact', flow_impact)
      Object.values(analysis_data.ingredients).forEach((x) => {
        if (x && !x.name) {
          var transport_data = x.filter((y) => y.category.name === k_type)[0];
          console.log('transport_data', transport_data)
          if (transport_data) {
            transport_data = transport_data.inputs.filter((y) => y && !y.is_agricultural);
            flow_impact += transport_data.reduce((acc, crr) => {
              const coefficient = parseFloat(crr.flow.flow_impact_factors.find((x) => x.id === indicator_id).coefficient);
              const conversion_factor = parseFloat(crr.unit.conversion_factor);
              const amount = parseFloat(crr.amount);
              acc += parseFloat(coefficient * conversion_factor * amount);
              return acc;
            }, 0);
          }
        }
      });
    }

    return flow_impact ? flow_impact : 0;
  };

  const get_step_id_from_text = (text) => {
    switch (text) {
      case "Recette":
        return 2;
      case "Packaging":
        return 3;
      case "Distribution":
        return 4;
      case "Vente au détail":
        return 5;
      case "Consommation":
        return 6;
      default:
        break;
    }
  };

  var percentageTransport = ((calculStepImpactIndicator(get_step_id_from_text(text), "da32f256-618d-4bec-a8d9-205817788b26", "K_Transports") / totalScore) * 100).toFixed(0);
  var percentageEnergy = ((calculStepImpactIndicator(get_step_id_from_text(text), "da32f256-618d-4bec-a8d9-205817788b26", "K_Energies") / totalScore) * 100).toFixed(0);
  var percentagePackaging = ((calculStepImpactIndicator(get_step_id_from_text(text), "da32f256-618d-4bec-a8d9-205817788b26", "K_Packaging") / totalScore) * 100).toFixed(0);
  // var percentageTransport = 0;
  // var percentageEnergy = 0;
  // var percentagePackaging = 0;

  return (
    <>
      <div className="w-[350px] h-[180px] rounded-xl bg-white border-green-500 shadow-2xl">
        <div className="text-center text-2xl font-Poppins-SemiBold h-[50px] flex items-end justify-center">
          <p>{text}</p>
        </div>

        <div className="h-[130px] items-center justify-center align-middle]">
          <div className="h-[100px] flex justify-evenly items-center font-Poppins-Light text-xs">
            <button
              onClick={() => {
                switch (text) {
                  case "Recette":
                    state.Recette.transport = !state.Recette.transport;
                    break;
                  case "Packaging":
                    state.Packaging.transport = !state.Packaging.transport;
                    break;
                  case "Distribution":
                    state.Distribution.transport = !state.Distribution.transport;
                    break;
                  case "Vente au detail":
                    state.VenteAuDetail.transport = !state.VenteAuDetail.transport;
                    break;
                  case "Consommation":
                    state.Consommation.transport = !state.Consommation.transport;
                    break;
                  default:
                    break;
                }
                update(state);
                setTransport(!transport);
                if (user_info.usage_info && user_info.usage_info.onboarding_step < 5) {
                  handleChangeOnboardingStep(5);
                }
              }}
            >
              {transport === false ? (
                <>
                  <div className="w-full flex justify-center items-center">
                    <Truck height={60} fill={"#bdc4cb"} />
                  </div>
                  <p className="w-full text-center text-gray-600/50 text-xs">Transport</p>
                  <div className="flex items-center justify-start">
                    <p className="text-gray-600/50 w-[15px] mr-[10px] text-center">
                      {indicator && indicator.id && calculStepImpactIndicator(get_step_id_from_text(text), indicator.id, "K_Transports").toFixed(2)}
                    </p>
                    <div className="w-[50px] h-[5px] rounded-full bg-gray-600/10">
                      <div className="bg-gray-600/50 h-full rounded-full max-w-[50px]" style={{ width: percentageTransport + "%" }} />
                    </div>
                  </div>
                  <p className="text-gray-600/50 text-center w-[100px]">
                    {/* {indicator && indicator.id && calculStepImpactIndicator(get_step_id_from_text(text), indicator.id, "K_Transports").toFixed(2)} */}
                    {/* {data.transport[indicator.id]} {" "} */}
                    {/* {indicator.unit} */}
                  </p>
                </>
              ) : (
                <>
                  <div className="w-[full] flex justify-center items-center">
                    <Truck height={60} fill={"#169A6A"} />
                  </div>
                  <p className="text-mainGreen w-full text-center text">Transport</p>
                  <div className="flex items-center justify-start">
                    <p className="text-mainGreen w-[15px] mr-[10px] text-center">
                      {indicator && indicator.id && calculStepImpactIndicator(get_step_id_from_text(text), indicator.id, "K_Transports").toFixed(2)}
                    </p>
                    <div className="w-[50px] h-[5px] rounded-full bg-mainGreen/20">
                      <div className="bg-mainGreen h-full rounded-full max-w-[50px]" style={{ width: percentageTransport + "%" }} />
                    </div>
                  </div>
                  <p className="text-mainGreen text-center w-[100px]">
                    {/* {data.transport[indicator.id]} {" "} */}
                    {/* {indicator.ref_unit} */}
                  </p>
                </>
              )}
            </button>

            <button
              onClick={() => {
                switch (text) {
                  case "Recette":
                    state.Recette.energy = !state.Recette.energy;
                    break;
                  case "Packaging":
                    state.Packaging.energy = !state.Packaging.energy;
                    break;
                  case "Distribution":
                    state.Distribution.energy = !state.Distribution.energy;
                    break;
                  case "Vente au detail":
                    state.VenteAuDetail.energy = !state.VenteAuDetail.energy;
                    break;
                  case "Consommation":
                    state.Consommation.energy = !state.Consommation.energy;
                    break;
                  default:
                    break;
                }
                update(state);
                setEnergy(!energy);
                if (user_info.usage_info && user_info.usage_info.onboarding_step < 5) {
                  handleChangeOnboardingStep(5);
                }
              }}
            >
              {energy === false ? (
                <>
                  <div className="w-full flex justify-center items-center">
                    <Spark height={60} fill={"#bdc4cb"} />
                  </div>
                  <p className="w-full text-center text-gray-600/50 text-xs">Energie</p>
                  <div className="flex items-center justify-start">
                    <p className="text-gray-600/50 w-[15px] mr-[10px] text-center">
                      {indicator && indicator.id && calculStepImpactIndicator(get_step_id_from_text(text), indicator.id, "K_Energies").toFixed(2)}
                    </p>
                    <div className="w-[50px] h-[5px] rounded-full bg-gray-600/10">
                      <div className="bg-gray-600/50 h-full rounded-full max-w-[50px]" style={{ width: percentageEnergy + "%" }} />
                    </div>
                  </div>
                  <p className="text-gray-600/50 text-center w-[100px]">
                    {/* {data.energy[indicator.id]} {" "}
                  {indicator.unit} */}
                  </p>
                </>
              ) : (
                <>
                  <div className="w-[full] flex justify-center items-center">
                    <Spark height={60} fill={"#169A6A"} />
                  </div>
                  <p className="text-mainGreen w-full text-center">Energie</p>
                  <div className="flex items-center justify-start">
                    <p className="text-mainGreen w-[15px] mr-[10px] text-center">
                      {indicator && indicator.id && calculStepImpactIndicator(get_step_id_from_text(text), indicator.id, "K_Energies").toFixed(2)}
                    </p>
                    <div className="w-[50px] h-[5px] rounded-full bg-mainGreen/20">
                      <div className="bg-mainGreen h-full rounded-full max-w-[50px]" style={{ width: percentageEnergy + "%" }} />
                    </div>
                  </div>
                  <p className="text-mainGreen text-center w-[100px]">
                    {/* {data.energy[indicator.id]} {" "}
                  {indicator.unit} */}
                  </p>
                </>
              )}
            </button>

            <button
              onClick={() => {
                switch (text) {
                  case "Recette":
                    state.Recette.packaging = !state.Recette.packaging;
                    break;
                  case "Packaging":
                    state.Packaging.packaging = !state.Packaging.packaging;
                    break;
                  case "Distribution":
                    state.Distribution.packaging = !state.Distribution.packaging;
                    break;
                  case "Vente au detail":
                    state.VenteAuDetail.packaging = !state.VenteAuDetail.packaging;
                    break;
                  case "Consommation":
                    state.Consommation.packaging = !state.Consommation.packaging;
                    break;
                  default:
                    break;
                }
                update(state);
                setPackaging(!packaging);
                if (user_info.usage_info && user_info.usage_info.onboarding_step < 5) {
                  handleChangeOnboardingStep(5);
                }
              }}
            >
              {packaging === false ? (
                <>
                  <div className="w-[full] flex justify-center items-center">
                    <Box height={60} fill={"#bdc4cb"} />
                  </div>
                  <p className="w-full text-center text-gray-600/50 text-xs">Emballage</p>
                  <div className="flex items-center justify-start">
                    <p className="text-gray-600/50 w-[15px] mr-[10px] text-center">
                      {indicator && indicator.id && calculStepImpactIndicator(get_step_id_from_text(text), indicator.id, "K_Packaging").toFixed(2)}
                    </p>
                    <div className="w-[50px] h-[5px] rounded-full bg-gray-600/10">
                      <div className="bg-gray-600/50 h-full rounded-full" style={{ width: percentagePackaging + "%" }} />
                    </div>
                  </div>
                  <p className="text-gray-600/50 text-center w-[100px]">
                    {/* {data.packaging[indicator.id]} {" "}
                  {indicator.unit} */}
                  </p>
                </>
              ) : (
                <>
                  <div className="w-[full] flex justify-center items-center">
                    <Box height={60} fill={"#169A6A"} />
                  </div>
                  <p className="text-mainGreen w-full text-center">Emballage</p>
                  <div className="flex items-center justify-start">
                    <p className="text-mainGreen w-[15px] mr-[10px] text-center">
                      {indicator && indicator.id && calculStepImpactIndicator(get_step_id_from_text(text), indicator.id, "K_Packaging").toFixed(2)}
                    </p>
                    <div className="w-[50px] h-[5px] rounded-full bg-mainGreen/20">
                      <div className="bg-mainGreen h-full rounded-full max-w-[50px]" style={{ width: percentagePackaging + "%" }} />
                    </div>
                  </div>
                  <p className="text-mainGreen text-center w-[100px]">
                    {/* {data.packaging[indicator.id]} {" "}
                  {indicator.unit} */}
                  </p>
                </>
              )}
            </button>
          </div>

          <div className="justify-center text-center font-Poppins-Light text-xs mt-[5px] text-gray-600/50">
            <p>{indicator.ref_unit}</p>
          </div>
        </div>

        {/* </div> */}
      </div>
    </>
  );
};

export default ReductionOption;
